<template>
  <!-- eslint-disable vue/no-v-html -->
  <div>
    <v-container
      class="align-stretch top pa-10"
      fluid
    >
      <v-row
        v-if="loading || (coach.profile.qualifications || coach.profile.accreditations)"
        class="ma-0"
        :class="coach.profile.testimonials && coach.profile.testimonials.length ? 'mb-8' : ''"
      >
        <span class="title mb-6">
          <span class="brandFont font-weight-bold">Qualifications & Accreditations</span>
        </span>

        <div
          class="body-2"
          style="width: 100%"
        >
          <v-skeleton-loader
            :loading="loading"
            width="700"
            type="paragraph@3"
          >
            <div :class="coach.profile.accreditations ? 'mb-3' : ''">
              <div
                id="qualificationRender"
                class="brandFont fiveHundred ql-editor px-0"
                v-html="coach.profile.qualifications"
              ></div>
            </div>

            <ul v-if="coach.profile.accreditations">
              <li
                v-for="(acc, key) in coach.profile.accreditations"
                :key="key"
                class="pb-1"
                style="word-break: break-word;"
              >
                <span class="brandFont fiveHundred">{{ acc }}</span>
              </li>
            </ul>
          </v-skeleton-loader>
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Section5',

  props: {
    coach: {
      type: Object,
      default: null,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
  #qualificationRender {
    &.ql-editor {
      * {
        word-break: break-word !important;
        white-space: normal !important;
        color: black !important;
      }
    }
  }
</style>
